import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import { Dropdown } from '@patternfly/react-core/dist/js/components/Dropdown';
import { KebabToggle } from '@patternfly/react-core/dist/js/components/Dropdown/KebabToggle';
import { DropdownItem } from '@patternfly/react-core/dist/js/components/Dropdown/DropdownItem';
import { DropdownSeparator } from '@patternfly/react-core/dist/js/components/Dropdown/DropdownSeparator';
import { DropdownDirection, DropdownPosition } from '@patternfly/react-core/dist/js/components/Dropdown/dropdownConstants';
export var ActionsColumn = /*#__PURE__*/function (_React$Component) {
  _inherits(ActionsColumn, _React$Component);

  var _super = _createSuper(ActionsColumn);

  function ActionsColumn(props) {
    var _this;

    _classCallCheck(this, ActionsColumn);

    _this = _super.call(this, props);

    _this.onToggle = function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    };

    _this.onSelect = function (event, onClick) {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          extraData = _this$props.extraData; // Only prevent default if onClick is provided.  This allows href support.

      if (onClick) {
        event.preventDefault(); // tslint:disable-next-line:no-unused-expression

        onClick(event, extraData && extraData.rowIndex, rowData, extraData);
      }

      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(ActionsColumn, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          items = _this$props2.items,
          children = _this$props2.children,
          dropdownPosition = _this$props2.dropdownPosition,
          dropdownDirection = _this$props2.dropdownDirection,
          isDisabled = _this$props2.isDisabled;
      return React.createElement(React.Fragment, null, React.createElement(Dropdown, {
        toggle: React.createElement(KebabToggle, {
          isDisabled: isDisabled,
          onToggle: this.onToggle
        }),
        position: dropdownPosition,
        direction: dropdownDirection,
        isOpen: isOpen,
        dropdownItems: items.map(function (_a, key) {
          var title = _a.title,
              itemKey = _a.itemKey,
              _onClick = _a.onClick,
              isSeparator = _a.isSeparator,
              props = __rest(_a, ["title", "itemKey", "onClick", "isSeparator"]);

          return isSeparator ? React.createElement(DropdownSeparator, Object.assign({}, props, {
            key: itemKey || key,
            "data-key": itemKey || key
          })) : React.createElement(DropdownItem, Object.assign({
            component: "button",
            onClick: function onClick(event) {
              return _this2.onSelect(event, _onClick);
            }
          }, props, {
            key: itemKey || key,
            "data-key": itemKey || key
          }), title);
        }),
        isPlain: true
      }), children);
    }
  }]);

  return ActionsColumn;
}(React.Component);
ActionsColumn.displayName = 'ActionsColumn';
ActionsColumn.defaultProps = {
  children: null,
  items: [],
  dropdownPosition: DropdownPosition.right,
  dropdownDirection: DropdownDirection.down,
  rowData: {},
  extraData: {}
};